const state = {
  creditsPercentageUse: 0,
  creditsUseLast30Days: 0,
  creditsUseToday: 0,
  creditsUseLast30DaysChart: {
    series: [],
    xAxis: [],
  },
};

export default state;
